(function () {
  // Currencies commonly supported by Afterpay/Clearpay.
  // Adjust for your markets if needed.
  var SUPPORTED = new Set(["AUD","NZD","USD","CAD","GBP","EUR"]);

  function moneyFormatFromTheme() {
    // Dawn sets this on window.Shopify and uses a money format string in theme settings.
    // If not present, fall back to a basic format.
    if (window.theme && window.theme.moneyFormat) return window.theme.moneyFormat;
    if (window.Shopify && window.Shopify.money_format) return window.Shopify.money_format;
    return "${{amount}}";
  }

  function formatMoney(cents, moneyFormat) {
    // Use Shopify's formatter if available (best for currency formatting + decimals)
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    // Fallback (simple)
    var value = (cents / 100).toFixed(2);
    return moneyFormat.replace("{{amount}}", value);
  }

  async function getCart() {
    var res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("Unable to load cart.js");
    return await res.json();
  }

  function setVisibility(el, show) {
    el.style.display = show ? "" : "none";
  }

  async function updateAfterpayMessage() {
    var container = document.querySelector("[data-afterpay-message]");
    if (!container) return;

    try {
      var cart = await getCart();

      // Shopify returns:
      // cart.total_price (in cents)
      // cart.currency (ISO code) in newer themes/stores
      // sometimes: cart.presentment_currency, or currency via Shopify.currency.active
      var currency =
        cart.currency ||
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.shop_currency) ||
        "";

      currency = (currency || "").toUpperCase();

      // Hide if not supported (optional)
      if (currency && !SUPPORTED.has(currency)) {
        setVisibility(container, false);
        return;
      }
      setVisibility(container, true);

      var total = cart.total_price || 0;

      // Pay-in-4 calculation (rounded to nearest cent)
      var installment = Math.round(total / 4);

      var moneyFormat = moneyFormatFromTheme();

      // If you want to show currency code explicitly, swap the format string to one that includes it.
      // Many themes already display in active currency.
      var text = formatMoney(installment, moneyFormat);

      var amountEl = container.querySelector("[data-afterpay-amount]");
      if (amountEl) amountEl.textContent = text;

    } catch (e) {
      // If anything fails, just hide it to avoid a broken UI
      setVisibility(container, false);
    }
  }

  // Run on load
  document.addEventListener("DOMContentLoaded", updateAfterpayMessage);

  // Re-run when cart updates (Dawn dispatches events; apps often do too)
  document.addEventListener("cart:refresh", updateAfterpayMessage);
  document.addEventListener("cart:updated", updateAfterpayMessage);

  // Fallback: update when drawer opens / DOM changes
  var mo = new MutationObserver(function () {
    // debounce-ish
    clearTimeout(window.__afterpayDrawerTimer);
    window.__afterpayDrawerTimer = setTimeout(updateAfterpayMessage, 150);
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
